import type { ApiRoutes } from '@mesa/functions';
import { Octokit as OctoCore } from '@octokit/core';
import { paginateGraphQL } from '@octokit/plugin-paginate-graphql';
import { QueryClient } from '@tanstack/react-query';
import { hc } from 'hono/client';
import { Octokit } from 'octokit';

export const queryClient = new QueryClient();

const apiUrl = import.meta.env.VITE_API_URL ?? '/api';

export const api = hc<ApiRoutes>(apiUrl, {
  init: {
    credentials: 'include',
    redirect: 'manual',
  },
});

export type Api = typeof api;

export const octokit: Octokit = new Octokit({
  request: {
    fetch: async (url: string, options: RequestInit) => {
      const proxiedUrl = url.replace('https://api.github.com/', `${apiUrl}/github/proxy/`);

      return fetch(proxiedUrl, {
        ...options,
        credentials: 'include',
      });
    },
  },
});

export const GQLOctokit = OctoCore.plugin(paginateGraphQL);
export const octogql = new GQLOctokit({
  request: {
    fetch: async (url: string, options: RequestInit) => {
      const proxiedUrl = url.replace('https://api.github.com/', `${apiUrl}/github/proxy/`);

      return fetch(proxiedUrl, {
        ...options,
        credentials: 'include',
      });
    },
  },
});
